module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.e2f51af7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-LightItalic.ttf
// module id = 3672
// module chunks = 70